const centralStateTypes = {
    UNKNOWN: 'unknown',
    POWERED_ON: 'poweredOn',
    POWERED_OFF: 'poweredOff',
}

export default centralStateTypes;